import {schematicSdk} from './schematic-sdk';

export default {
    schematicSdk,
};
